import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKixieIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M19.79 4.592H3.97v15.324h15.82z",
		fill: "#fff"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.32 0H7.68A7.68 7.68 0 0 0 0 7.68V24h16.32A7.68 7.68 0 0 0 24 16.32V7.68A7.68 7.68 0 0 0 16.32 0m.116 18.973h-3.797l-1.498-5.114H9.563l-.94 5.114H5.027L7.565 5.027h3.596l-1.06 5.81h1.28l3.796-5.81h3.796l-4.575 7.031z",
		fill: "#f10606"
	})]
});
export default SvgKixieIcon;
